import React, { Component } from "react";
import { connect } from "react-redux";
import {
  retrieveAutres,
  findAutresByTitle,
  deleteAllAutres,
} from "../actions/autre";
import { Link } from "react-router-dom";

class AutresList extends Component {
  constructor(props) {
    super(props);
    this.onChangeSearchNom = this.onChangeSearchNom.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.setActiveAutre = this.setActiveAutre.bind(this);
    this.findByNom = this.findByNom.bind(this);
    this.removeAllAutres = this.removeAllAutres.bind(this);

    this.state = {
      currentAutre: null,
      currentIndex: -1,
      searchNom: "",
    };
  }

  componentDidMount() {
    this.props.retrieveAutres();

  }

  onChangeSearchNom(e) {
    const searchNom = e.target.value;

    this.setState({
      searchNom: searchNom,
    });
  }

  refreshData() {
    this.setState({
      currentAutre: null,
      currentIndex: -1,
    });
  }

  setActiveAutre(autre, index) {
    this.setState({
      currentAutre: autre,
      currentIndex: index,
    });
  }

  removeAllAutres() {
    this.props
      .deleteAllAutres()
      .then((response) => {
        console.log(response);
        this.refreshData();
      })
      .catch((e) => {
        console.log(e);
      });
  }

  findByNom() {
    this.refreshData();

    this.props.findAutresByTitle(this.state.searchNom);
  }

  render() {
    const { searchNom, currentAutre, currentIndex } = this.state;
    const { autres } = this.props;


    return (
      <div className="list row">
        <div className="col-md-8">
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Rechercher un produit"
              value={searchNom}
              onChange={this.onChangeSearchNom}
            />

            <div className="input-group-append">
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={this.findByNom}
              >
                Rechercher
              </button>

            </div>

          </div>
        </div>
        <div className="col-md-6">
          <h4>Liste des produits</h4>

          <ul className="list-group">

            {autres &&
              autres.map((autre, index) => (

                  <li
                  className={
                    "list-group-item " +
                    (index === currentIndex ? "active" : "")
                  }

                  onClick={() => this.setActiveAutre(autre)}
                  key={autre.id}

                >
                    <ul> {autre.Nom}
                    </ul>
                    <ul><img className="img" src={autre.Img1} alt={autre.Img1}/></ul>
                </li>


              ))}
          </ul>

          <button
            className="m-3 btn btn-sm btn-danger"
            onClick={this.removeAllAutres}
          >
            Supprimer toutes les produits
          </button>
        </div>
        <div className="col-md-6">
          {currentAutre ? (
            <div>
              <h4>Autre</h4>
              <div>
                <label>
                  <strong>Nom:</strong>
                </label>{" "}
                {currentAutre.Nom}
              </div>
              <div>
                <label>
                  <strong>Status:</strong>
                </label>{" "}
                {currentAutre.published ? "Published" : "Pending"}
              </div>

              <Link
                to={"/autres/" + currentAutre.id}
                className="badge badge-warning"
              >
                Editer
              </Link>
            </div>
          ) : (
            <div>
              <br />
              <p>Cliquez sur un produit ou  </p>
              <p>  <a className="nav-item"
                            href="https://gestion.attirail.fr/addautres" type="button"> Ajouter un produit </a>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    autres: state.autres,
  };
};

export default connect(mapStateToProps, {
  retrieveAutres,
  findAutresByTitle,
  deleteAllAutres,
})(AutresList);
